'use strict';

function AdminController() {
  var vm = this;

  vm.$onInit = $onInit;

  function $onInit() {}
}

module.exports = AdminController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/admin/admin.controller.js
 ** module id = 167
 ** module chunks = 0
 **/